import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { HomeNavbar } from '@iarc-programing/emanufac-components/src/components/Navbars';
import { MainFooter } from '@iarc-programing/emanufac-components/src/components/Footers';
import { MainSidebar } from '@iarc-programing/emanufac-components/src/components/Sidebar';
import { Loading } from '@iarc-programing/emanufac-components/src/components/Loading';
import { Landing as LandingPage } from '../views/Landing';
import * as actions from '../redux/actions';

export function Landing() {
  const dispatch = useDispatch();
  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    console.log('Layout : Landing');
    dispatch(actions.meGet());
    dispatch(actions.informationAll());
    dispatch(actions.availableModuleAll());
    return () => {};
  }, []);

  if (!me?.userData) {
    return <Loading />;
  }

  return (
    <div className="min-h-screen">
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
      <div className="relative lg:ml-64  min-h-screen  pt-16 px-8 ">
        <div className="py-4">
          <Switch>
            <Route path="/">
              <LandingPage />
            </Route>
          </Switch>
        </div>
      </div>
      <div className="lg:ml-64">
        <MainFooter />
      </div>
    </div>
  );
}
export default Landing;
